import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

Alpine.plugin(collapse);

/**
 * Загрузка stores и components
 */
const modules = import.meta.glob('./components/*.js', { eager: true });
const stores  = import.meta.glob('./stores/*.js', { eager: true });

/**
 * 1. РЕГИСТРАЦИЯ STORES
 * ❗ обязательно ДО alpine:init
 */
for (const path in stores) {
    const register = stores[path].default;

    if (typeof register === 'function') {
        register(Alpine);
    }
}

/**
 * 2. BOOTSTRAP
 */
document.addEventListener('alpine:init', () => {
    const app = window.__APP__ || {};

    Alpine.store('app', {
        csrf: app.csrf,
        routes: app.routes,
    });

    if (app.cart) {
        Alpine.store('cart').sync(app.cart);
    }

    if (app.favorites) {
        Alpine.store('favorites').init(app.favorites);
    }

    if (app.city) {
        Alpine.store('city').init(app.city);
    }

    /**
     * Регистрация компонентов
     */
    for (const path in modules) {
        const name = path
            .replace('./components/', '')
            .replace('.js', '');

        Alpine.data(name, modules[path].default);
    }
});

/**
 * 3. СТАРТ ALPINE
 */
window.Alpine = Alpine;
Alpine.start();

import 'fslightbox';
